// extracted by mini-css-extract-plugin
module.exports = {"container":"UnderContructionSection_container__3BgNk","image":"UnderContructionSection_image__2gLI7","title":"UnderContructionSection_title__3H_zP"};